import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=eba6e28a&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eba6e28a')) {
      api.createRecord('eba6e28a', component.options)
    } else {
      api.reload('eba6e28a', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=eba6e28a&", function () {
      api.rerender('eba6e28a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lEcC2vEBvGyG/JS/comp/ImgFallback.vue"
export default component.exports